import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = {
  isPending: false,
  isSuccessful: false,
  isFailure: false,
};

const reduceState = createStateReducer(initialState, {
  [events.changePlanzoneLogoRequested]: setRequestStateToPending,
  [events.changePlanzoneLogoSucceeded]: setRequestStateToSuccess,
  [events.changePlanzoneLogoFailed]: setRequestStateToFailure,
});

export type { State, Selector };

export { reduceState, initialState, createSelector };
